import { registerPageInit } from '../barba/page-init-registry';
import {
  initDateRangePicker,
  populateDateRangeFromURL,
} from '../utils/date-range-picker';
import { refreshEventStatusLabels } from '../utils/event-status';
import {
  initEventsCalendarLoadMore,
} from '../utils/events-calendar-load-more';
import { initEventsCalendarView } from '../utils/events-calendar-view';
import { updateActivityFiltersEmptySummary } from '../utils/activity-filters-summary';
import { updateRangeEmptySummary } from '../utils/date-range-summary';
import { initNewsFiltersAutoSubmit } from '../utils/news-filters';
import { applyServerSearchResults, initSearchInput } from '../utils/search-input';
import { initStcSelect } from '../utils/stc-select';
import {
  EVENTS_CALENDAR_AJAX_CONFIG,
  EVENTS_CALENDAR_FILTER_SUBMIT_OPTIONS,
} from '../widgets/events-calendar-filter/events-calendar-filter-config';
import { initEventsCalendarFilter } from '../widgets/events-calendar-filter';
import '../../css/_root.scss';
import '../../css/pages/news/index.scss';

function getEventsCalendarScope(root?: ParentNode): ParentNode {
  return (
    root?.querySelector<HTMLElement>('[data-barba-namespace="news-events-calendar"]') ??
    root ??
    document
  );
}

class NewsEventsCalendar {
  public init(root?: ParentNode): void {
    const scope = getEventsCalendarScope(root);
    initDateRangePicker(scope);
    populateDateRangeFromURL(scope);
    this.populateOtherFiltersFromURL(scope);
    initStcSelect(scope);
    initSearchInput(scope, { mode: 'server', urlParam: 'q' });
    initEventsCalendarView(scope);
    initEventsCalendarFilter(scope);

    initNewsFiltersAutoSubmit(scope, EVENTS_CALENDAR_FILTER_SUBMIT_OPTIONS);
    updateRangeEmptySummary(scope, EVENTS_CALENDAR_AJAX_CONFIG);
    updateActivityFiltersEmptySummary(scope, EVENTS_CALENDAR_AJAX_CONFIG);

    const urlQuery = new URLSearchParams(window.location.search).get('q');
    if (urlQuery) {
      applyServerSearchResults(scope, urlQuery, EVENTS_CALENDAR_AJAX_CONFIG.search);
    }

    initEventsCalendarLoadMore(scope);
    refreshEventStatusLabels(scope);
  }

  private populateOtherFiltersFromURL(root: ParentNode = document): void {
    const activityFormatSelect = root.querySelector<HTMLSelectElement>('#activity_format');
    const activityTypeSelect = root.querySelector<HTMLSelectElement>('#activity_type');

    if (!activityFormatSelect || !activityTypeSelect) return;

    const urlParams = new URLSearchParams(window.location.search);
    const activityFormatParam = urlParams.get('activity_format');
    if (activityFormatParam) {
      activityFormatSelect.value = activityFormatParam;
    }

    const activityTypeParam = urlParams.get('activity_type');
    if (activityTypeParam) {
      activityTypeSelect.value = activityTypeParam;
    }
  }
}

registerPageInit('news-events-calendar', (root) => {
  const page = new NewsEventsCalendar();
  page.init(root);
});
